// Keep location mandatory, but distinguish denied permission from unavailable GPS.
export const requestTimesheetLocation = () => new Promise((resolve, reject) => {
    if (window.isSecureContext === false) {
        reject(new Error('Location needs a secure connection. Open this page using https:// and try again.'))
        return
    }
    if (!navigator.geolocation) {
        reject(new Error('Location is not supported by this browser. Open the timesheet in Safari or Chrome.'))
        return
    }
    const fail = error => reject(new Error(error.code === 1
        ? 'Location access is blocked. Allow location for this website in your browser settings, then save again.'
        : 'Your location could not be found. Check that phone location services are on and try saving again. Your entries have been kept.'))
    const success = position => resolve([position.coords.latitude, position.coords.longitude])
    navigator.geolocation.getCurrentPosition(success, error => {
        if (error.code === 1) return fail(error)
        // Network positioning can succeed indoors when high-accuracy GPS times out.
        navigator.geolocation.getCurrentPosition(success, fail, { enableHighAccuracy: false, timeout: 10000, maximumAge: 0 })
    }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 })
})
